import {ReactNode, useCallback} from 'react'
import {getTotalGuests} from 'utils/guestCounterHelpers'
import {FoldingProvider} from '../../providers/FoldingProvider'
import {InputProvider} from '../../providers/InputProvider'
import {StepDataProvider} from '../../providers/StepDataProvider'

type RenderProps = {
  onClick: () => void
  disabled: boolean
}

type Props = {
  onClick: () => void
  onError: (error: unknown) => void
  render: (props: RenderProps) => ReactNode
}

export const ApplyButton = ({onClick, onError, render}: Props) => {
  const activeStepCode = FoldingProvider.useActiveStepCode()
  const dataManager = StepDataProvider.useStepDataManager(activeStepCode)
  const unitCounters = InputProvider.useUnitCounters('optional')
  const availabilityId = InputProvider.useAvailabilityId('optional')
  const optionId = InputProvider.useOptionId('optional')

  const disabled = Boolean(getTotalGuests(unitCounters) === 0 || !availabilityId || !optionId)

  const resultOnClick = useCallback(() => {
    if (disabled) {
      return
    }

    if (dataManager && !dataManager.isValid()) {
      onError(dataManager.hint)
      return
    }

    onClick()
  }, [onClick, onError, dataManager, disabled])

  return <>{render({onClick: resultOnClick, disabled})}</>
}
